export default __webpack_public_path__ + "images/4367346ac28805080b5c5f2abc470e01.png";